import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VSnackbarQueue from '@tozd/vue-snackbar-queue';

Vue.use(Vuetify);
Vue.use(VSnackbarQueue);

/*
Grün: 2fab60
Orange: ee7203
Grau: 5b595a
*/

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: '#2fab60',
        // secondary: '#ee7203',
        // accent: '#5b595a',
        // anchor: '#8c9eff',
        primary: '#ee7203',
        secondary: '#2fab60',
        accent: '#f5f5f5',
      },
    },
  },
});
